import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormFieldConfig, FieldSelectedValue } from '../../../model/form.model';
import { CamelCasePipe } from "../../../utils/camel-case.pipe";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-mat-checkbox-list-field',
  standalone: true,
  imports: [CommonModule, MatListModule, MatCheckboxModule, CamelCasePipe, MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatSelectModule],
  templateUrl: './mat-checkbox-list-field.component.html',
  styleUrl: './mat-checkbox-list-field.component.scss'
})
export class MatCheckboxListFieldComponent implements OnInit{
  @Input()
    field!: FormFieldConfig | undefined;
  @Input() form!: FormGroup;
  @Output() selectionChanged = new EventEmitter<FieldSelectedValue>();
  public checkboxGroup: { [key: string]: boolean } = {};
  public isValid = true;
  ngOnInit() {
    const fieldName = this.field?.fieldName;
    if(fieldName){
    const control = this.form.get(fieldName);
    if (control) {
      this.form.valueChanges.subscribe(() => {
        this.dynamicFieldDisabled();
        
      });
      this.dynamicFieldDisabled();
    }
    }
    

  }
  dynamicFieldDisabled(): void {
    const fieldName = this.field?.fieldName;
    const control = fieldName && this.form.get(fieldName);
    const shouldDisable = this.field?.disabled;
    if (control) {
      shouldDisable ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
    }
  }
  onCheckBoxChange(FieldName: string,Value?: any): void {
  if (this.field) {
    this.field.selectedValue = Value;
    this.selectionChanged.emit({FieldName: FieldName,Value: this.field.selectedValue});
  }
}

  onSelectionListChange(FieldName: string, event: MatSelectionListChange): void {
    const selectedValues = event.source.selectedOptions.selected.map((option) => option.value);
    this.onCheckBoxChange(FieldName, selectedValues);
  }
}
